import controller from './device.controller'
import template   from './device.html'
import './device.styl'

let component = {
  restrict: 'E',
  bindings: {
    device: '<',
    vehicle: '<',
    sdfilter: '<',
    onSynchronize: '&',
    onFilterAction: '&',
    onShowHideBeforeApiCall: '&'
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/device/device.component.js